import PropTypes from 'prop-types';
import { ConditionCardItem } from './ConditionCardItem';
import Carousel from '@iscr/contentful/components/Carousel';

/**
 * A carousel component for condition cards.
 *
 * It uses `embla-carousel` under the hood and will automatically scroll through the
 * condition cards when the component is mounted. The carousel is only visible on
 * mobile devices.
 *
 * @param {{title: string, imageUrl: string, url: string}[]} items - An array of condition card items.
 */
const ConditionCardCarousel = ({ items }) => {
  return (
    <section className="w-full sm:hidden">
      <Carousel items={items.map((item, index) => <ConditionCardItem {...item} key={index} />)} />
    </section>
  );
};

ConditionCardCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ConditionCardCarousel;
